//@flow
import env from '../../environment';
import {postCreator, getCreator, deleteCreator} from '../../http';

export const endpoints = Object.freeze({
  VALIDATE_SSL: `${env.baseApiUrl}/usher/autossl/validate`,
  GENERATE_SSL: `${env.baseApiUrl}/usher/autossl`,
  GET_DOMAINS: `${env.baseApiUrl}/usher/store/:storeId/domain`,
  DELETE_CUSTOM_DOMAIN: `${env.baseApiUrl}/usher/admin/store/custom-domain`,
});

export const validateSslApi = getCreator(endpoints.VALIDATE_SSL);
export const generateSslApi = postCreator(endpoints.GENERATE_SSL);
export const getDomainsApi = getCreator(endpoints.GET_DOMAINS);
export const deleteCustomDomainApi = deleteCreator(
  endpoints.DELETE_CUSTOM_DOMAIN
);
